import { styled } from "@mui/system";

export const Wrapper = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("xl")]: {
    a: {
      fontSize: "16px",
    },
  },
}));
